const EmailSoundType = {
    SWOOSH: "swoosh",
};

export default EmailSoundType;